import Repository from "./RepositoryFactoryMain";

const ADD_COUPON = "add";
const DELETE_COUPON = "delete";
const UPDATE_COUPON = "update";
const GET_COUPON = "get";

export default {
  getCoupon(payload) {
    return Repository.post(transformRoute(GET_COUPON), payload);
  },
  addCoupon(payload) {
    return Repository.post(transformRoute(ADD_COUPON), payload);
  },
  updateCoupon(payload) {
    return Repository.post(transformRoute(UPDATE_COUPON), payload);
  },
  deleteCoupon(payload) {
    return Repository.post(transformRoute(DELETE_COUPON), payload);
  },
};

const transformRoute = (route) => {
  return `/Ecom/coupon/${route}`;
};
